
//vuex 状态容器
import store from "@/extra/store.js"

const hotKey = {};

// let store.state.baseData.hotKeyPointer = "";

hotKey.install = function (Vue,options) {

    Vue.directive('popLevel', {
      bind: function(el, {value}, vnode) {
        let KeyPointer;
        if(typeof value != "undefined" && value != ""){
          KeyPointer = value+"";
        }else{
          let dateV = new Date().valueOf();
          KeyPointer = "date_"+ dateV;
        }

        if(hotKeyObj.currentSCall){
          hotKeyObj.altSList[KeyPointer] = hotKeyObj.currentSCall;
        }
        if(hotKeyObj.currentXCall){
          hotKeyObj.altXList[KeyPointer] = hotKeyObj.currentXCall;
        }
        if(hotKeyObj.currentACall){
          hotKeyObj.altAList[KeyPointer] = hotKeyObj.currentACall;
        }
        if(hotKeyObj.currentFCall){
          hotKeyObj.altFList[KeyPointer] = hotKeyObj.currentFCall;
        }

        hotKeyObj.currentSCall = null;
        hotKeyObj.currentXCall = null;
        hotKeyObj.currentACall = null;
        hotKeyObj.currentFCall = null;

        store.commit("changeHotKeyPointer",KeyPointer);

        hotKeyObj.levelStack.push(KeyPointer);

      },
      unbind: function(el, {value}, vnode) {

        if(store.state.baseData.hotKeyPointer && store.state.baseData.hotKeyPointer.indexOf("date_") != -1){

          delete hotKeyObj.altSList[store.state.baseData.hotKeyPointer];
          delete hotKeyObj.altXList[store.state.baseData.hotKeyPointer];
          delete hotKeyObj.altAList[store.state.baseData.hotKeyPointer];
          delete hotKeyObj.altFList[store.state.baseData.hotKeyPointer];

          hotKeyObj.levelStack.splice(hotKeyObj.levelStack.length - 1,1);

          let hadDate = false;
          for(var i=0;i<hotKeyObj.levelStack.length;i++){
            if(hotKeyObj.levelStack[i].indexOf("date_") != -1){
              hadDate = true;
            }
          }

          if(hadDate){
            store.state.baseData.hotKeyPointer = hotKeyObj.levelStack[hotKeyObj.levelStack.length - 1];
          }else{
            store.state.baseData.hotKeyPointer = store.state.componentList.currentComponentId
          }
        }else{
          store.state.baseData.hotKeyPointer = store.state.componentList.currentComponentId
        }


      },
    });

   Vue.directive('keyAltS', {
     bind: function(el, {value}, vnode) {
       hotKeyObj.currentSCall = value;
     },
     unbind: function(el, {value}, vnode) {
       // delete hotKeyObj.altSList[store.state.baseData.hotKeyPointer];
     }
   });

   Vue.directive('keyAltX', {
     bind: function(el, {value}, vnode) {
       hotKeyObj.currentXCall = value;
     },
     unbind: function(el, {value}, vnode) {
       // delete hotKeyObj.altXList[store.state.baseData.hotKeyPointer];
     }
   });

  Vue.directive('keyAltA', {
    bind: function(el, {value}, vnode) {
      hotKeyObj.currentACall = value;
    },
    unbind: function(el, {value}, vnode) {
      // delete hotKeyObj.altAList[store.state.baseData.hotKeyPointer];
    }
  });

  Vue.directive('keyAltF', {
    bind: function(el, {value}, vnode) {
      hotKeyObj.currentFCall = value;
    },
    unbind: function(el, {value}, vnode) {
      // delete hotKeyObj.altAList[store.state.baseData.hotKeyPointer];
    }
  });

  Vue.directive('keyEsc', {
    bind: function(el, {value}, vnode) {
      hotKeyObj.currentACall = value;
    },
    unbind: function(el, {value}, vnode) {
      // delete hotKeyObj.altAList[store.state.baseData.hotKeyPointer];
    }
  });


 };


const hotKeyObj = {
  levelStack:[],
  altSList:{},
  currentSCall:null,
  altXList:{},
  currentXCall:null,
  altAList:{},
  currentACall:null,
  altFList:{},
  currentFCall:null,
  hotKeyDown:function (e) {
    // console.log("当前作用域ID:"+store.state.baseData.hotKeyPointer)
    if(83 == e.keyCode && e.altKey) {// "点击了alt+s";
      e.preventDefault();
      let callBack = hotKeyObj.altSList[store.state.baseData.hotKeyPointer];
      if(callBack && typeof callBack === "function"){
        callBack();
      }
    }

    if(88 == e.keyCode && e.altKey) {// "点击了alt+x";
      e.preventDefault();
      let callBack = hotKeyObj.altXList[store.state.baseData.hotKeyPointer];
      if(callBack && typeof callBack === "function"){
        callBack();
      }
    }


    if(65 == e.keyCode && e.altKey) {// "点击了alt+a";
      e.preventDefault();
      let callBack = hotKeyObj.altAList[store.state.baseData.hotKeyPointer];
      if(callBack && typeof callBack === "function"){
        callBack();
      }
    }

    if(70 == e.keyCode && e.altKey) {// "点击了alt+f";
      e.preventDefault();
      let callBack = hotKeyObj.altFList[store.state.baseData.hotKeyPointer];
      if(callBack && typeof callBack === "function"){
        callBack();
      }
    }

    if(27 == e.keyCode) {// "点击了esc";
      e.preventDefault();
      let callBack = hotKeyObj.altAList[store.state.baseData.hotKeyPointer];
      if(callBack && typeof callBack === "function"){
        callBack();
      }
    }

  }
};

$(document).bind("keydown",hotKeyObj.hotKeyDown);


export default hotKey;



// WEBPACK FOOTER //
// ./src/extra/hotKey.js